import React from 'react';
import Logo from 'images/logos/geskus-landing-logo.png';

const landingWrapper = {
  paddingTop: '25px',
};

const logoStyle = {
  position: 'relative',
  top: 0,
  left: 0,
  width: '150px',
  height: '150px',
};

const headerStyle = {
  marginTop: '30px',
};

const LandingGeskus = (props) => {
  const { history, setActiveComponent } = props;

  return (
    <div className="gb-landing" style={landingWrapper}>
      <div className="gb-landing__top geskus-landing__container clearfix">
        <div>
          <div className="geskus-landing__logo" alt="" style={logoStyle}>
            <img className="" alt="Geskus Logo" src={Logo} />
          </div>
          <h1 className="gb-landing__center__header" style={headerStyle}>
            Welcome
          </h1>
          <h3 className="gb-landing__top__center__subheader">
            To Geskus Studios &amp; Yearbook Publishing online ordering!
          </h3>
          <h3 className="gb-landing__top__center__subheader">
            For security purposes, you must create an account to place an order.
          </h3>
          <div
            className="gb-landing__center__signup-button cursor-pointer"
            onClick={() => history.push('/account-lookup', { step: 1 })}
          >
            Place Your Order
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingGeskus;
